import {
    WebPost,
    WebGet,
} from '../lib/api.request'
import {
    resolve
} from 'url';
import {
    rejects
} from 'assert';




export default class RegJson {
    //userId, password,tempuserguid,smscode, unitname
    reqReg(reginfo) {
        var bodyJson = {
            mobilenum: reginfo.mobilenum,
            userid: reginfo.userid,
            pwd: reginfo.password,
            tempuserguid: reginfo.tempuserguid,
            smscode: reginfo.smscode,
            workunit: reginfo.unitname,
            login: true
        }
        console.log('request reg====>')
        console.log(reginfo)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/security/user/reg', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    reqRegV2(reginfo) {
        var bodyJson = {
            userid: reginfo.userid,
            mobilenum: reginfo.mobilenum,
            tempuserguid: reginfo.tempuserguid,
            password: reginfo.password,
            smscode: reginfo.smscode,
            workunit: reginfo.unitname,
            companytel:reginfo.unittel,
            province:reginfo.province,
            city:reginfo.city,
            industry:reginfo.industrycode,
            login: true
        }
        console.log('request reg2====>')
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/security/user/v2/reg', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }


    reqSmsCode(telnum, regsrc) {
        var bodyJson = {
            reqsrc: regsrc, //reg-注册,'resetpwd'-修改密码
            mobilenum: telnum,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/security/user/getsmscode', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })

    }
    //验证验证码
    reqRegCheckSmsCode(telnum, smscode, codetype) {
        var bodyJson = {
            mobilenum: telnum,
            smscode: smscode,
            smscodetype: codetype,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/security/user/checksmscode', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })

    }

    //重置密码
    reqSetPwd(telnum, pwd, smscode) {
        var bodyJson = {
            mobilenum: telnum,
            pwd: pwd,
            smscode: smscode,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/security/user/resetpwd', bodyJson)
                .then(function(resp) {
                    console.log(resp)
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })

    }

    //重置微信
    reqSetWXToken(smscode) {
        var bodyJson = {
            smscode: smscode,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/security/user/resetboundwechat', bodyJson)
                .then(function(resp) {
                    console.log(resp)
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }


    //修改密码
    reqEditPwd(oripwd, newpwd) {
        var bodyJson = {
            oripwd: oripwd,
            newpwd: newpwd,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/security/user/updatepwd', bodyJson)
                .then(function(resp) {
                    console.log(resp)
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })

    }

    reqMobileBind(value) {
        var bodyJson = {
            mobile: value.mobile,
            smscode: value.smscode
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/security/user/bindmobile', bodyJson)
                .then(function(resp) {
                    //console.log(resp)
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    reqMobileUpdate(value) {
        var bodyJson = {
            mobilenum_old: value.mobilenum_old,
            smscode_old: value.smscode_old,
            mobilenum_new: value.mobilenum_new,
            smscode_new: value.smscode_new,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/security/user/mobileupdate', bodyJson)
                .then(function(resp) {
                    console.log(resp)
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //校验用户ID是否有效
    reqCheckUserId(telnum, userId) {
        var bodyJson = {
            mobilenum: telnum,
            expectuserid: userId,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/security/user/checkid', bodyJson)
                .then(function(resp) {
                    console.log(resp)
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })

    }

     //关联临时用户数据
    reqLinkTempUser(args) {
        var bodyJson = {
            matchuserguid: args.matchuserguid,
            reguserguid: args.reguserguid,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('api/public/security/user/syncmatch', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }




}